import { Form, message, Modal, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchTemplates, pauseStatusUpdate } from "../../redux/actions/templateActions";
import HeaderSelector from "../../components/companyTemplates/headerSelector"
import get from "lodash/get";
import debounce from "lodash/debounce";
import assign from "lodash/assign"
import { companyTemplateColumns } from "../../constants/tableColumns/companyTemplates";
import { fetchConfig } from "../../redux/actions/authActions";
import { fetchCompanies } from "../../redux/actions/companyActions";
import EditTemplate from "../../components/companyTemplates/editTemplate";
import { PAUSE_UPDATE_FAILED, PAUSE_UPDATE_SUCCESS } from "../../constants/message";
import requireAuth from "../../hocs/requireAuth";
import { COMPANY_ADMIN_ROLE_ACCESS } from "../../constants";
import { replaceMultiple } from "../../utilities/helpers";

const TemplateCompanyAdminScreen = () => {
      const [form] = Form.useForm();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const searchRef = useRef(null)
    const [ config, setConfig ] = useState({})
    const [templates, setTemplates] = useState({
        data: [],
        pagination:null,
        filters:{page: 1, companies: undefined, query: undefined,limit: 15,},
    })
    const [templateForm, setTemplateForm] = useState({ data: null, visible: false })
    const toggleTemplateForm = (data = null) => {
        assign(templateForm, {
            visible: !get(templateForm, "visible"),
            data
        });
        setTemplateForm({ ...templateForm });
    };
    const getConfig = (companies) => {
        dispatch(fetchConfig("templates"))
            .then((result) => {
                setConfig({ ...config, template_types: result, companies:companies });
            })
            .catch(() => { });
    };
    const getCompanies = () => {
        dispatch(fetchCompanies())
            .then((result) => {
                
                getConfig(result)
            })
            .catch(() => { });
    };
    const getTemplates = (page = 1, filters = {}) => {
      setLoading(true);
      const payload = {
        ...filters,
        page,
      };
  
      if (!get(payload, "query") && searchRef.current) {
        searchRef.current.input.value = "";
        searchRef.current.focus();
      }
  
      dispatch(fetchTemplates(payload))
        .then((result) => {
          setLoading(false);
          setTemplates({
            data: get(result, "data"),
            pagination: get(result, "meta.pagination"),
            filters: filters,
          });
        })
        .catch(() => {
          setLoading(false);
        });
    };
  
    const onSearchTemplate = debounce((filters) => {
      getTemplates(1, filters);
    }, 500);

   const updatePauseStatus = (uuid,payload)=>{
    setLoading(true)
    dispatch(pauseStatusUpdate(uuid,payload))
    .then((result)=>{
      getTemplates(get(templates, "filters.page",1), get(templates, "filters"))
      console.log(result, "result")
      message.success(replaceMultiple(PAUSE_UPDATE_SUCCESS,{"{{status}}":get(payload, "status")?"resumed":"paused"}));
      setLoading(false)
    })
    .catch((error)=>{
      console.log(error,"error")
      setLoading(false)
      message.error(PAUSE_UPDATE_FAILED)
    })
  }

    useEffect(() => {
           getTemplates(get(templates, "filters.page",1), get(templates, "filters"));
        getCompanies()
    }, [])
    return (
        <Spin spinning={loading}>
            <div className="pl-2 py-2 h-full flex flex-col">
                <div className="flex flex-row justify-between pb-4">
                    <p className="text-xl font-medium leading-[30px] text-black-1">
                        Company Templates
                    </p>
                </div>
               <div className="h-full rounded-xl overflow-hidden bg-white flex-1 overflow-y-auto scrollbar-hidden pb-5 min-w-full ">
                  <div className="w-full px-8 py-6">
                    <HeaderSelector searchRef={searchRef} onSearchTemplate={onSearchTemplate} config={config} updateTemplates={getTemplates} templates={templates} />
                    </div>
                 <div className="px-8 overflow-y-auto">
                        <Table dataSource={get(templates, "data")} columns={companyTemplateColumns(updatePauseStatus, toggleTemplateForm)}
                          pagination={{
                                        pageSize: get(templates, "pagination.per_page", 1),
                                        current: get(templates, "pagination.current_page", 1),
                                        total: get(templates, "pagination.total", 1),
                                        onChange: (val, pageSize) => {
                                          getTemplates(val, { ...get(templates, "filters"), limit:pageSize });
                                        },
                                      }}
                                     rowKey={(record) => get(record, "id") || crypto.randomUUID()} />
                    </div>
                </div>
                <Modal destroyOnHidden title="Edit Template"
                    centered
                    open={get(templateForm, "visible")}
                     onOk={() => {form.submit();
                     }} 
                    onCancel={toggleTemplateForm}
                    width={600} >
                        <EditTemplate  form={form} initialValues={get(templateForm, "data")} config={config} setLoading={setLoading} toggleTemplateForm={toggleTemplateForm}
                             refresh={()=>getTemplates(get(templates, "filters.page",1),get(templates, "filters"))} />
                    </Modal>
            </div>
        </Spin>
    )
}
export default requireAuth(TemplateCompanyAdminScreen, COMPANY_ADMIN_ROLE_ACCESS);